import {Component, Inject, inject, OnInit} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {TextButton} from '../../../../shared/components/text-button/text-button.component';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MAT_DIALOG_DATA, MatDialog, MatDialogClose, MatDialogRef} from '@angular/material/dialog';
import {AuthenticationService} from '../../authentication.service';
import {SetPasswordDialog} from '../set-password/set-password.dialog';
import {HttpErrorResponse} from '@angular/common/http';
import {ErrorService} from '../../../../core/services/error.service';
import {ResetPasswordDto} from '../../dtos/reset-password.dto';
import {MemoryService} from '../../../../core/services/memory.service';

@Component({
  selector: 'app-reset-password',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    TextButton,
    TranslocoPipe,
    MatDialogClose
  ],
  templateUrl: './reset-password.dialog.html',
  styleUrl: './reset-password.dialog.scss'
})
export class ResetPasswordDialog implements OnInit {
  dialogRef = inject(MatDialogRef<ResetPasswordDialog>);
  authenticationService: AuthenticationService = inject(AuthenticationService);
  dialog: MatDialog = inject(MatDialog);
  translocoService = inject(TranslocoService);
  errorService = inject(ErrorService);
  memoryService = inject(MemoryService);

  email!: FormControl;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { email: string }) {
  }

  ngOnInit() {
    this.email = new FormControl(this.data.email);
  }

  resetPassword() {
    const language = navigator.language.split('-')[0];
    const resetPasswordDto: ResetPasswordDto = {email: this.email.value, language: language, customerId: this.memoryService.customerId, locationId: this.memoryService.locationId};
    this.authenticationService.resetPassword(resetPasswordDto).subscribe({
      next: () => {
        this.dialog.open(SetPasswordDialog, {autoFocus: false}).afterClosed().subscribe((value: any) => {
          if (value?.success) {
            this.dialogRef.close()
          }
        });
      },
      error: (error: HttpErrorResponse) => {
        this.errorService.handleError(error, this.translocoService.translate('error.title.resetPassword'));
      }
    })
  }
}
